import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import { ThingsToDoCard } from '../TripPlanDetailDrawer.styles'
import ListItemThumbnail from 'LuxKit/List/ListItemThumbnail'
import { TRIP_LIST_CATEGORY_COLOURS } from '../ListView/tripListCategoryColours'

const EXPERIENCES_COLOURS = TRIP_LIST_CATEGORY_COLOURS['entertainment-and-leisure']

/* `&&` to outrank ListItemThumbnail's own `.kind-*` rule, which is two classes deep. The Trip Kit
   category ramp has no LuxKit `kind` to ask for. */
const ExperiencesThumbnail = styled(ListItemThumbnail)`
  && {
    width: ${rem(40)};
    height: ${rem(40)};
    border-radius: ${rem(10)};
    background-color: ${EXPERIENCES_COLOURS.background};
    color: ${EXPERIENCES_COLOURS.foreground};
  }

  svg {
    width: ${rem(16)};
    height: ${rem(16)};
  }
`

interface Props {
  count: number
  formattedLowestPrice?: string
  onClick: () => void
}

function ThingsToDoExperiencesRow({ count, formattedLowestPrice, onClick }: Props) {
  const intl = useIntl()

  const label = formattedLowestPrice
    ? intl.formatMessage(
        {
          id: 'TAtpVtulcA2goUlYQ266',
          defaultMessage: '{count, plural, one {# Luxury Escape experience} other {# Luxury Escape experiences}} from {price}/person',
          description: 'Row on the trip planner things to do places list that crosses over to the bookable Luxury Escapes experiences for the same destination, showing the cheapest of them',
        },
        { count, price: formattedLowestPrice },
      )
    : intl.formatMessage(
        {
          id: 'bVUkxA6QzaCwuysvaA_c',
          defaultMessage: '{count, plural, one {# Luxury Escape experience} other {# Luxury Escape experiences}}',
          description: 'Row on the trip planner things to do places list that crosses over to the bookable Luxury Escapes experiences for the same destination, when none of them carry a price',
        },
        { count },
      )

  return (
    <ThingsToDoCard
      size="medium"
      title={label}
      titleWeight="bold"
      onClick={onClick}
      startIcon={
        <ExperiencesThumbnail gutter="none">
          <LineTicketIcon size="XS" />
        </ExperiencesThumbnail>
      }
      endIcon={<LineAngleRightIcon size="S" rtlFlip />}
    />
  )
}

export default ThingsToDoExperiencesRow
